<template>
  <nav-bar title="举报" />
  <Content :bottom="0" >
    <van-form class="form" @submit="handleSubmit">
      <van-field
        v-model="message"
        rows="3"
        autosize
        label="举报内容"
        type="textarea"
        placeholder="请输入举报内容"
         :rules="[{ required: true, message: '请填写举报内容' }]"
      />
      <van-field name="uploader" label="举报图片" >
        <template #input>
          <van-uploader  v-model="fileList" :after-read="afterRead"  />
        </template>
      </van-field>
      <div class="btn">
        <van-button block type="primary" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { report } from '@/api/viewGasCylinder'
import { useSubmit } from '@/hooks/useSubmit'
import { useRouter } from 'vue-router'
import getImgFile from '@/utils/getImgFile'
export default {
  name: 'ReportDetail', // 举报
  props: ['uuid'],
  setup (props) {
    // 文件上传
    const fileList = ref([])
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach(item => {
        if (item.status === 'done') {
          arr.push(item.content || item.url)
        }
      })
      return arr
    })
    const afterRead = (file) => {
      getImgFile(file, fileList)
    }
    const router = useRouter()
    const message = ref('')
    const handleSubmit = () => {
      const params = {
        gsId: props.uuid,
        content: message.value,
        title: message.value,
        imgList: imgPath.value
      }
      const { onSubmit } = useSubmit(report, params, () => {
        router.back()
      })
      onSubmit()
    }
    return { message, handleSubmit, fileList, afterRead, imgPath }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 16px;
}
::v-deep(.van-field__body) {
  /* border: 1px solid #f8f8f8;
  padding: 5px; */
}
.btn {
  margin: 16px;
}
</style>
